// ABOUTME: Warning/alert triangle icon for highlighting important information
// ABOUTME: Used in tooltips and notifications for warnings and errors

import type { FC } from "react"

interface AlertTriangleIconProps {
  className?: string
  size?: number
  color?: string
}

export const AlertTriangleIcon: FC<AlertTriangleIconProps> = ({
  className = "",
  size = 16,
  color = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line
      x1="12"
      y1="9"
      x2="12"
      y2="13"
    />
    <line
      x1="12"
      y1="17"
      x2="12.01"
      y2="17"
    />
  </svg>
)
